const datePicker = (name) => {
    const wrapper = document.createElement('div')
    wrapper.className = 'lux-picker'
    wrapper.style.cssText = 'position:relative;width:100%;'

    let style = document.getElementById('lux-datepicker-styles')
    if (!style) {
        style = document.createElement('style')
        style.id = 'lux-datepicker-styles'
        document.head.appendChild(style)
    }
    style.textContent = `
            .lux-picker {
                box-sizing: border-box;
                padding: 4px 11px;
                border: 1px solid rgb(238, 237, 237);
                border-radius: 6px;
                background: #fff;
                display: inline-flex;
                align-items: center;
                width: 100%;
                min-height: 32px;
                transition: border-color 0.2s, box-shadow 0.2s;
                cursor: text;
                gap: 4px;
            }
            .lux-picker:hover:not(.lux-picker-disabled) {
                border-color: rgb(0, 0, 0);
            }
            /* Active / focus — Impower black border + matching underline mask */
            .lux-picker.lux-picker-focused:not(.lux-picker-disabled) {
                border-color: #000;
                box-shadow: none;
            }
            .lux-picker.lux-picker-focused:not(.lux-picker-disabled) .lux-picker-mask,
            .lux-picker.lux-picker-focused:not(.lux-picker-disabled) .lux-picker-mask-rest {
                color: #000;
            }
            /* Only lux-picker-disabled locks the field. Impower often adds .read-only to
               .DateInput / form shells; that must not block keyboard typing. */
            .lux-picker.lux-picker-disabled {
                pointer-events: none;
                cursor: default;
                border: 1px solid rgb(238, 237, 237);
                background: rgb(238, 237, 237);
                min-height: 32px;
            }
            .lux-picker.lux-picker-disabled .lux-picker-input {
                color: rgba(0, 0, 0, 0.85) !important;
                -webkit-text-fill-color: rgba(0, 0, 0, 0.85) !important;
                opacity: 1 !important;
                font-weight: 400;
            }
            .lux-picker.lux-picker-disabled .lux-picker-mask {
                color: #000;
            }
            .lux-picker.lux-picker-disabled .lux-picker-suffix {
                display: none;
            }
            .lux-picker:not(.lux-picker-disabled) .lux-picker-input {
                pointer-events: auto;
                cursor: text;
                user-select: text;
                -webkit-user-select: text;
            }
            .lux-picker-field {
                position: relative;
                flex: 1;
                min-width: 0;
                display: flex;
                align-items: center;
            }
            .lux-picker-mask {
                position: absolute;
                inset: 0;
                display: flex;
                align-items: center;
                pointer-events: none;
                font-size: 16px;
                line-height: 1.5715;
                font-weight: 500;
                font-family: inherit;
                white-space: pre;
                /* Impower brand black — same when focused or idle */
                color: #000;
            }
            .lux-picker-mask-rest {
                color: inherit;
            }
            .lux-picker-mask-typed {
                visibility: hidden;
            }
            .lux-picker-input {
                position: relative;
                z-index: 1;
                flex: 1;
                min-width: 0;
                width: 100%;
                border: none;
                outline: none;
                background: transparent;
                font-size: 16px;
                line-height: 1.5715;
                color: rgba(0, 0, 0, 0.88);
                font-weight: 500;
            }
            .lux-picker-input::placeholder {
                color: transparent !important;
            }
            .lux-picker-suffix {
                position: relative;
                display: flex;
                align-items: center;
                color: rgba(0, 0, 0, 0.54);
                flex-shrink: 0;
            }
            .lux-picker-icon-btn {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border: none;
                background: none;
                padding: 0;
                margin: 0;
                cursor: pointer;
                color: inherit;
                line-height: 0;
            }
            .lux-picker-icon-btn:hover {
                color: rgba(0, 0, 0, 0.88);
            }
            .lux-picker-dropdown {
                position: absolute;
                top: calc(100% + 4px);
                right: 0;
                left: auto;
                transform: none;
                z-index: 1050;
                background: #fff;
                border-radius: 8px;
                box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
                display: none;
            }
            .lux-picker-dropdown.open {
                display: block;
            }
            .lux-picker-panel {
                padding: 20px;
                width: 310px;
                box-sizing: border-box;
            }
            .lux-picker-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 4px;
                margin-bottom: 16px;
            }
            .lux-picker-header-view {
                flex: 1;
                text-align: center;
                font-weight: 600;
                font-size: 16px;
                color: rgba(0, 0, 0, 0.87);
                cursor: pointer;
                padding: 4px 8px;
                border-radius: 4px;
                transition: background 0.2s;
                border: none;
                background: none;
                font-family: inherit;
            }
            .lux-picker-header-view:hover {
                background: rgba(0, 0, 0, 0.04);
            }
            .lux-picker-header-btn {
                border: none;
                background: none;
                cursor: pointer;
                padding: 8px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background 0.2s;
            }
            .lux-picker-header-btn:hover {
                background: rgba(0, 0, 0, 0.04);
            }
            .lux-picker-header-btn svg {
                display: block;
            }
            .lux-picker-days-header {
                display: flex;
                justify-content: space-around;
                margin-bottom: 8px;
            }
            .lux-picker-day-label {
                width: 36px;
                text-align: center;
                font-size: 12px;
                color: rgba(0, 0, 0, 0.38);
                font-weight: 400;
            }
            .lux-picker-weeks {
                display: flex;
                flex-direction: column;
                gap: 4px;
            }
            .lux-picker-week {
                display: flex;
                justify-content: space-around;
            }
            .lux-picker-day-wrapper {
                width: 36px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .lux-picker-day {
                width: 36px;
                height: 36px;
                border: none;
                background: none;
                border-radius: 50%;
                cursor: pointer;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.87);
                transition: background 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .lux-picker-day:hover {
                background: rgba(0, 0, 0, 0.04);
            }
            .lux-picker-day.selected {
                background: rgba(0, 0, 0, 0.87);
                color: #fff;
            }
            .lux-picker-day.selected:hover {
                background: rgba(0, 0, 0, 0.7);
            }
            .lux-picker-month-grid,
            .lux-picker-year-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 8px;
            }
            .lux-picker-month-cell,
            .lux-picker-year-cell {
                padding: 12px 8px;
                text-align: center;
                border: none;
                background: none;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.87);
                transition: background 0.2s;
            }
            .lux-picker-month-cell:hover,
            .lux-picker-year-cell:hover {
                background: rgba(0, 0, 0, 0.04);
            }
            .lux-picker-month-cell.selected,
            .lux-picker-year-cell.selected {
                background: rgba(0, 0, 0, 0.87);
                color: #fff;
            }
            .lux-picker-body-days,
            .lux-picker-body-months,
            .lux-picker-body-years {
                display: none;
            }
            .lux-picker-body-days.active,
            .lux-picker-body-months.active,
            .lux-picker-body-years.active {
                display: block;
            }
        `

    wrapper.innerHTML = `
        <div class="lux-picker-field">
            <div class="lux-picker-mask" aria-hidden="true">
                <span class="lux-picker-mask-typed"></span><span class="lux-picker-mask-rest">__.__.____</span>
            </div>
            <input type="text" class="lux-picker-input" placeholder="TT.MM.JJJJ" name="${name}" autocomplete="off" inputmode="numeric" />
        </div>
        <span class="lux-picker-suffix">
            <button type="button" class="lux-picker-icon-btn" aria-label="Kalender öffnen" tabindex="-1">
                <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" width="20" height="20" fill="currentColor">
                    <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"></path>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                </svg>
            </button>
            <div class="lux-picker-dropdown">
                <div class="lux-picker-panel">
                    <div class="lux-picker-header">
                        <button type="button" class="lux-picker-header-btn prev-btn" aria-label="Zurück">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.47159 11.0739L0.306818 5.90909L5.47159 0.744318L6.49432 1.76705L3.07955 5.17045H12V6.64773H3.07955L6.49432 10.0568L5.47159 11.0739Z" fill="black"></path>
                            </svg>
                        </button>
                        <button type="button" class="lux-picker-header-view"></button>
                        <button type="button" class="lux-picker-header-btn next-btn" aria-label="Weiter">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.52841 11.0739L11.6932 5.90909L6.52841 0.744318L5.50568 1.76705L8.92045 5.17045H0V6.64773H8.92045L5.50568 10.0568L6.52841 11.0739Z" fill="black"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="lux-picker-body-days active">
                        <div class="lux-picker-days-header">
                            <span class="lux-picker-day-label">Mo</span>
                            <span class="lux-picker-day-label">Di</span>
                            <span class="lux-picker-day-label">Mi</span>
                            <span class="lux-picker-day-label">Do</span>
                            <span class="lux-picker-day-label">Fr</span>
                            <span class="lux-picker-day-label">Sa</span>
                            <span class="lux-picker-day-label">So</span>
                        </div>
                        <div class="lux-picker-weeks"></div>
                    </div>
                    <div class="lux-picker-body-months">
                        <div class="lux-picker-month-grid"></div>
                    </div>
                    <div class="lux-picker-body-years">
                        <div class="lux-picker-year-grid"></div>
                    </div>
                </div>
            </div>
        </span>
    `

    const input = wrapper.querySelector('input')
    const maskTyped = wrapper.querySelector('.lux-picker-mask-typed')
    const maskRest = wrapper.querySelector('.lux-picker-mask-rest')
    const iconBtn = wrapper.querySelector('.lux-picker-icon-btn')
    const dropdown = wrapper.querySelector('.lux-picker-dropdown')
    const headerView = wrapper.querySelector('.lux-picker-header-view')
    const prevBtn = wrapper.querySelector('.prev-btn')
    const nextBtn = wrapper.querySelector('.next-btn')
    const weeksContainer = wrapper.querySelector('.lux-picker-weeks')
    const bodyDays = wrapper.querySelector('.lux-picker-body-days')
    const bodyMonths = wrapper.querySelector('.lux-picker-body-months')
    const bodyYears = wrapper.querySelector('.lux-picker-body-years')
    const monthGrid = wrapper.querySelector('.lux-picker-month-grid')
    const yearGrid = wrapper.querySelector('.lux-picker-year-grid')

    const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
                        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
    const monthNamesShort = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni',
                             'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.']

    const now = new Date()
    let selectedDate = null
    let viewMonth = now.getMonth()
    let viewYear = now.getFullYear()
    let viewMode = 'days'
    let yearRangeStart = Math.floor(now.getFullYear() / 12) * 12
    let isDisabled = false

    const setViewMode = (mode) => {
        viewMode = mode
        bodyDays.classList.remove('active')
        bodyMonths.classList.remove('active')
        bodyYears.classList.remove('active')

        if (mode === 'days') {
            bodyDays.classList.add('active')
        } else if (mode === 'months') {
            bodyMonths.classList.add('active')
        } else if (mode === 'years') {
            bodyYears.classList.add('active')
        }

        render()
    }

    const renderDays = () => {
        headerView.textContent = `${monthNames[viewMonth]} ${viewYear}`

        const firstDay = new Date(viewYear, viewMonth, 1)
        const lastDay = new Date(viewYear, viewMonth + 1, 0)

        let startDay = firstDay.getDay() - 1
        if (startDay < 0) startDay = 6

        const daysInMonth = lastDay.getDate()

        let html = ''
        let dayCounter = 1 - startDay

        for (let week = 0; week < 6; week++) {
            if (dayCounter > daysInMonth) break

            html += '<div class="lux-picker-week">'
            for (let day = 0; day < 7; day++) {
                const isOtherMonth = dayCounter < 1 || dayCounter > daysInMonth

                if (isOtherMonth) {
                    html += '<div class="lux-picker-day-wrapper"></div>'
                } else {
                    const isSelected = selectedDate &&
                        selectedDate.getDate() === dayCounter &&
                        selectedDate.getMonth() === viewMonth &&
                        selectedDate.getFullYear() === viewYear

                    let classes = 'lux-picker-day'
                    if (isSelected) classes += ' selected'

                    html += `<div class="lux-picker-day-wrapper"><button type="button" class="${classes}" data-date="${viewYear}-${String(viewMonth + 1).padStart(2, '0')}-${String(dayCounter).padStart(2, '0')}">${dayCounter}</button></div>`
                }
                dayCounter++
            }
            html += '</div>'
        }

        weeksContainer.innerHTML = html
    }

    const renderMonths = () => {
        headerView.textContent = `${viewYear}`

        let html = ''
        for (let i = 0; i < 12; i++) {
            const isSelected = selectedDate &&
                selectedDate.getMonth() === i &&
                selectedDate.getFullYear() === viewYear
            const classes = isSelected ? 'lux-picker-month-cell selected' : 'lux-picker-month-cell'
            html += `<button type="button" class="${classes}" data-month="${i}">${monthNamesShort[i]}</button>`
        }
        monthGrid.innerHTML = html
    }

    const renderYears = () => {
        headerView.textContent = `${yearRangeStart} – ${yearRangeStart + 11}`

        let html = ''
        for (let i = 0; i < 12; i++) {
            const year = yearRangeStart + i
            const isSelected = selectedDate && selectedDate.getFullYear() === year
            const classes = isSelected ? 'lux-picker-year-cell selected' : 'lux-picker-year-cell'
            html += `<button type="button" class="${classes}" data-year="${year}">${year}</button>`
        }
        yearGrid.innerHTML = html
    }

    const render = () => {
        if (viewMode === 'days') {
            renderDays()
        } else if (viewMode === 'months') {
            renderMonths()
        } else if (viewMode === 'years') {
            renderYears()
        }
    }

    const formatDisplayDate = (date) => {
        if (!date) return ''
        const d = String(date.getDate()).padStart(2, '0')
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const y = date.getFullYear()
        return `${d}.${m}.${y}`
    }

    /** Typed digits → dd.MM.yyyy (no underscores in the real input value). */
    const formatTypedDateDisplay = (raw) => {
        if (!raw) return ''
        const digits = String(raw).replace(/\D/g, '').slice(0, 8)
        if (!digits) return ''
        if (digits.length <= 2) return digits
        if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`
        return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`
    }

    /** Full guide e.g. 1_.__.__.__ — used for the always-visible remainder overlay. */
    const getDateMaskGuide = (raw) => {
        const digits = String(raw || '').replace(/\D/g, '').slice(0, 8)
        const padded = digits.padEnd(8, '_')
        return `${padded.slice(0, 2)}.${padded.slice(2, 4)}.${padded.slice(4, 8)}`
    }

    const updateMaskOverlay = () => {
        const typed = formatTypedDateDisplay(input.value)
        const guide = getDateMaskGuide(typed)
        const digits = typed.replace(/\D/g, '')

        if (digits.length >= 8) {
            maskTyped.textContent = ''
            maskRest.textContent = ''
            return
        }

        // Empty → full __.__.____; partial → remainder after typed chars (visible even when blurred)
        const remainder = guide.startsWith(typed) ? guide.slice(typed.length) : guide
        maskTyped.textContent = typed
        maskRest.textContent = remainder || '__.__.____'
    }

    const parseDisplayDate = (str) => {
        if (!str) return null
        const clean = String(str).replace(/_/g, '').trim()
        const parts = clean.split('.')
        if (parts.length !== 3) return null
        const [d, m, y] = parts.map(Number)
        if (isNaN(d) || isNaN(m) || isNaN(y) || y < 1000) return null
        const date = new Date(y, m - 1, d)
        if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null
        return date
    }

    const parseIsoOrDisplay = (value) => {
        if (!value) return null
        const str = String(value).trim()
        // ISO date/timestamp first — do not use includes('.') (ms like .000Z look like display dates)
        if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
            const [y, m, d] = str.split('T')[0].split('-').map(Number)
            if (isNaN(y) || isNaN(m) || isNaN(d) || y < 1000) return null
            const date = new Date(y, m - 1, d)
            if (
                isNaN(date.getTime()) ||
                date.getFullYear() !== y ||
                date.getMonth() !== m - 1 ||
                date.getDate() !== d
            ) {
                return null
            }
            return date
        }
        if (str.includes('.')) return parseDisplayDate(str)
        return null
    }

    const toIsoString = (date) => {
        const d = String(date.getDate()).padStart(2, '0')
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const y = date.getFullYear()
        return `${y}-${m}-${d}`
    }

    const positionDropdown = () => {
        const rect = wrapper.getBoundingClientRect()
        const panelWidth = 310
        const left = Math.min(
            Math.max(8, rect.right - panelWidth),
            window.innerWidth - panelWidth - 8
        )
        dropdown.style.position = 'fixed'
        dropdown.style.top = `${Math.round(rect.bottom + 4)}px`
        dropdown.style.left = `${Math.round(left)}px`
        dropdown.style.right = 'auto'
        dropdown.style.zIndex = '12000'
    }

    const openDropdown = () => {
        if (isDisabled) return
        const anchor = selectedDate || new Date()
        viewMonth = anchor.getMonth()
        viewYear = anchor.getFullYear()
        yearRangeStart = Math.floor(anchor.getFullYear() / 12) * 12
        // Portal to body so overflow ancestors (e.g. table scroll) cannot clip the calendar.
        if (dropdown.parentElement !== document.body) {
            document.body.appendChild(dropdown)
        }
        positionDropdown()
        dropdown.classList.add('open')
        wrapper.classList.add('lux-picker-focused')
        setViewMode('days')
    }

    const closeDropdown = () => {
        dropdown.classList.remove('open')
        dropdown.style.position = ''
        dropdown.style.top = ''
        dropdown.style.left = ''
        dropdown.style.right = ''
        dropdown.style.zIndex = ''
        if (dropdown.parentElement === document.body) {
            wrapper.appendChild(dropdown)
        }
        if (document.activeElement !== input) {
            wrapper.classList.remove('lux-picker-focused')
        }
    }

    const toggleDropdown = (e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        if (isDisabled) return
        if (dropdown.classList.contains('open')) {
            closeDropdown()
        } else {
            openDropdown()
        }
    }

    // Icon button only opens the calendar (not the text input)
    iconBtn.addEventListener('click', toggleDropdown)

    // Prevent suffix clicks from bubbling; don't open on field click
    wrapper.querySelector('.lux-picker-suffix').addEventListener('click', (e) => {
        e.stopPropagation()
    })

    // Clicking the field chrome focuses the text input for keyboard entry
    wrapper.addEventListener('click', (e) => {
        if (isDisabled) return
        if (e.target.closest('.lux-picker-suffix')) return
        if (document.activeElement !== input) input.focus()
    })

    input.addEventListener('focus', () => {
        if (isDisabled) return
        // Impower may stamp readonly on inputs inside .DateInput shells
        input.readOnly = false
        input.removeAttribute('readonly')
        wrapper.classList.add('lux-picker-focused')
    })

    input.addEventListener('blur', () => {
        setTimeout(() => {
            if (
                !wrapper.contains(document.activeElement) &&
                !dropdown.contains(document.activeElement)
            ) {
                wrapper.classList.remove('lux-picker-focused')
                closeDropdown()
            }
        }, 150)
    })

    /** Digits-only index for cursor placement after reformat. */
    const cursorAfterDigitCount = (formatted, digitsBefore) => {
        if (digitsBefore <= 0) return 0
        let digitCount = 0
        for (let i = 0; i < formatted.length; i++) {
            if (/\d/.test(formatted[i])) {
                digitCount++
                if (digitCount === digitsBefore) return i + 1
            }
        }
        return formatted.length
    }

    const applyFormattedValue = (raw, digitsBefore) => {
        const formatted = formatTypedDateDisplay(raw)
        input.value = formatted
        const cursor = cursorAfterDigitCount(formatted, digitsBefore)
        input.setSelectionRange(cursor, cursor)
        updateMaskOverlay()

        const parsed = parseDisplayDate(input.value)
        if (parsed && !isNaN(parsed.getTime())) {
            selectedDate = parsed
            viewMonth = parsed.getMonth()
            viewYear = parsed.getFullYear()
            yearRangeStart = Math.floor(viewYear / 12) * 12
            if (dropdown.classList.contains('open')) render()
        } else {
            selectedDate = null
        }
    }

    // Backspace/Delete must remove digits, not just separators (otherwise delete looks broken).
    input.addEventListener('keydown', (e) => {
        if (isDisabled) return
        if (e.key !== 'Backspace' && e.key !== 'Delete') return

        const start = input.selectionStart ?? 0
        const end = input.selectionEnd ?? 0
        const value = input.value

        // Selection delete → normal input path
        if (start !== end) return

        if (e.key === 'Backspace') {
            if (start === 0) return
            e.preventDefault()
            // Skip separators so Backspace always removes a digit
            let removeAt = start - 1
            while (removeAt >= 0 && /\D/.test(value[removeAt])) removeAt--
            if (removeAt < 0) {
                applyFormattedValue(value, 0)
                return
            }
            const next = value.slice(0, removeAt) + value.slice(removeAt + 1)
            const digitsBefore = next.slice(0, removeAt).replace(/\D/g, '').length
            applyFormattedValue(next, digitsBefore)
            input.dispatchEvent(new Event('input', { bubbles: true }))
            return
        }

        // Delete
        if (start >= value.length) return
        e.preventDefault()
        let removeAt = start
        while (removeAt < value.length && /\D/.test(value[removeAt])) removeAt++
        if (removeAt >= value.length) return
        const next = value.slice(0, removeAt) + value.slice(removeAt + 1)
        const digitsBefore = next.slice(0, removeAt).replace(/\D/g, '').length
        applyFormattedValue(next, digitsBefore)
        input.dispatchEvent(new Event('input', { bubbles: true }))
    })

    input.addEventListener('input', () => {
        const digitsBefore =
            input.value.slice(0, input.selectionStart || 0).replace(/\D/g, '').length
        applyFormattedValue(input.value, digitsBefore)
    })

    headerView.addEventListener('click', (e) => {
        e.stopPropagation()
        if (viewMode === 'days') {
            setViewMode('years')
        } else {
            setViewMode('days')
        }
    })

    prevBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        if (viewMode === 'days') {
            viewMonth--
            if (viewMonth < 0) {
                viewMonth = 11
                viewYear--
            }
        } else if (viewMode === 'months') {
            viewYear--
        } else if (viewMode === 'years') {
            yearRangeStart -= 12
        }
        render()
    })

    nextBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        if (viewMode === 'days') {
            viewMonth++
            if (viewMonth > 11) {
                viewMonth = 0
                viewYear++
            }
        } else if (viewMode === 'months') {
            viewYear++
        } else if (viewMode === 'years') {
            yearRangeStart += 12
        }
        render()
    })

    weeksContainer.addEventListener('click', (e) => {
        const cell = e.target.closest('.lux-picker-day')
        if (!cell) return

        const dateStr = cell.dataset.date
        const [y, m, d] = dateStr.split('-').map(Number)
        selectedDate = new Date(y, m - 1, d)
        input.value = formatDisplayDate(selectedDate)
        viewMonth = selectedDate.getMonth()
        viewYear = selectedDate.getFullYear()
        updateMaskOverlay()

        input.dispatchEvent(new Event('input', { bubbles: true }))
        input.dispatchEvent(new Event('change', { bubbles: true }))

        closeDropdown()
    })

    monthGrid.addEventListener('click', (e) => {
        const cell = e.target.closest('.lux-picker-month-cell')
        if (!cell) return

        viewMonth = parseInt(cell.dataset.month, 10)
        setViewMode('days')
    })

    yearGrid.addEventListener('click', (e) => {
        const cell = e.target.closest('.lux-picker-year-cell')
        if (!cell) return

        viewYear = parseInt(cell.dataset.year, 10)
        yearRangeStart = Math.floor(viewYear / 12) * 12
        setViewMode('months')
    })

    document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target) && !dropdown.contains(e.target)) {
            closeDropdown()
        }
    })

    window.addEventListener('scroll', () => {
        if (dropdown.classList.contains('open')) positionDropdown()
    }, true)
    window.addEventListener('resize', () => {
        if (dropdown.classList.contains('open')) positionDropdown()
    })

    input.setValue = (isoOrDisplay) => {
        if (!isoOrDisplay) {
            input.value = ''
            selectedDate = null
            updateMaskOverlay()
            return
        }
        const parsed = parseIsoOrDisplay(isoOrDisplay)
        if (!parsed) {
            input.value = formatTypedDateDisplay(String(isoOrDisplay).replace(/_/g, ''))
            selectedDate = null
            updateMaskOverlay()
            return
        }
        selectedDate = parsed
        viewMonth = selectedDate.getMonth()
        viewYear = selectedDate.getFullYear()
        yearRangeStart = Math.floor(viewYear / 12) * 12
        input.value = formatDisplayDate(selectedDate)
        updateMaskOverlay()
    }

    input.getValue = () => {
        if (!selectedDate) {
            const parsed = parseDisplayDate(input.value)
            if (parsed && !isNaN(parsed.getTime())) {
                return toIsoString(parsed)
            }
            return ''
        }
        return toIsoString(selectedDate)
    }

    input.setDisabled = (disabled) => {
        isDisabled = !!disabled
        input.disabled = isDisabled
        input.readOnly = false
        input.removeAttribute('readonly')
        input.setAttribute('placeholder', 'TT.MM.JJJJ')
        if (isDisabled) {
            wrapper.classList.add('lux-picker-disabled', 'read-only')
            closeDropdown()
        } else {
            wrapper.classList.remove('lux-picker-disabled', 'read-only')
        }
        updateMaskOverlay()
    }

    input.wrapper = wrapper
    updateMaskOverlay()
    render()
    return input
}
